import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import {
  FormFeedback,
  Col,
  Row,
  Label,
  Form,
  Input,
  Card,
  CardBody,
  Modal,
  Button,
} from "reactstrap"
import * as Yup from "yup"
import Swal from "sweetalert2"

import { addMaterialInTicket } from "helpers/fakebackend_helper"
import {
  getMaterialMasterForServiceRequest,
  getServiceRequestTicketDetail,
  getUnitMasterForServiceRequest,
} from "store/actions"

const LargeModal = ({ isOpen, toggle, id }) => {
  const dispatch = useDispatch()

  const materialMasterState = state => state.serviceRequests.materials.data
  const materialMaster = useSelector(materialMasterState) || []

  const unitMasterState = state => state.serviceRequests.units.data
  const unitMaster = useSelector(unitMasterState) || []

  useEffect(() => {
    dispatch(getMaterialMasterForServiceRequest())
    dispatch(getUnitMasterForServiceRequest())
  }, [dispatch])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      material: [],
    },

    validationSchema: Yup.object({}),
    onSubmit: async values => {
      let loadingSwal
      try {
        loadingSwal = Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })

        const response = await addMaterialInTicket(id, values)

        if (response && response.status === true) {
          loadingSwal.close()

          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Your Material has been updated.",
          }).then(result => {
            if (result.isConfirmed) {
              dispatch(getServiceRequestTicketDetail(id))
              toggle()
            }
          })
        } else {
          loadingSwal.close()

          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Your Material has not been updated.",
          })
        }
      } catch (error) {
        console.error("Error:", error)
        if (loadingSwal) {
          loadingSwal.close()
        }

        Swal.fire({
          title: "Error",
          icon: "error",
          text:
            error.response?.data?.message ||
            "An error occurred while updating your company location.",
        })
      }
    },
  })

  return (
    <Modal
      className="modal-dialog-centered"
      size="lg"
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myLargeModalLabel">
          Add Material
        </h5>
        <button
          onClick={toggle}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Card>
          <CardBody>
            <Form
              autoComplete="off"
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row>
                <div>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Material</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        <th>Amount</th>
                        <th>Upload Quotation File</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <select
                            className="form-select"
                            name={`material[0].material_id`}
                            // value={
                            //   validation?.values?.material_id
                            // }
                            onChange={validation.handleChange}
                          >
                            <option value="">Select Material</option>
                            {(materialMaster || []).map(item => (
                              <option key={item.id} value={item.id}>
                                {item.materials}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <Input
                            type="text"
                            name={`material[0].quantity`}
                            value={validation?.values?.quantity}
                            onChange={validation.handleChange}
                            placeholder="Enter Quantity"
                          />
                        </td>
                        <td>
                          <select
                            className="form-select"
                            name={`material[0].unit`}
                            // value={validation?.values?.material[key]?.unit}
                            onChange={validation.handleChange}
                          >
                            <option value="">Select Unit</option>
                            {(unitMaster || []).map(item => (
                              <option key={item.id} value={item.id}>
                                {item.unit}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <Input
                            type="text"
                            name={`material[0].unit_price`}
                            // value={
                            //   validation?.values?.material[key]?.unit_price
                            // }
                            onChange={validation.handleChange}
                            placeholder="Enter Amount"
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            id={`material[0].file_path`}
                            name={`material[0].file_path`}
                            onChange={e => {
                              const selectedFile = e.target.files[0]
                              validation.setFieldValue(
                                `material[0].file_path`,
                                selectedFile
                              )
                            }}
                            onBlur={validation.handleBlur}
                            className={`form-control ${
                              validation.touched[
                                `material[0].file_path`
                              ] &&
                              validation.errors[`material[0].file_path`]
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Row>
              <Row>
                <div className="mb-3 mt-4 text-center">
                  <button type="submit" className="btn btn-primary ">
                    Add Material
                  </button>
                </div>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </div>
    </Modal>
  )
}

export default LargeModal
